<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="矿权推介列表" name="1">
      <KytjAdd :updataID='updataID'></KytjAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 矿产品修改
 */
import KytjAdd from '../../../../static/form/KytjAdd.vue'
export default {
  components: {
    KytjAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Kqtjgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/KqtjUpdate.vue